import React, { useState, useRef, useEffect } from 'react';
import dine from '../Assets/dinde.webp'
import nugget from '../Assets/nugget.webp'
import poulet from '../Assets/poulet.webp'
import cataloquedinde from '../Assets/pdfs/cataloguedinde.pdf'
import cataloquenugget from '../Assets/pdfs/cataloguenuggets.pdf'
import cataloquepoulet from '../Assets/pdfs/cataloguepoulet.pdf'
import HeadingOfSection from './HeadingOfSection';
import { useTranslation } from 'react-i18next';


const ProductSection = ({isMob}) => {
    const {t, i18n} = useTranslation();
    const isRTL = i18n.language === 'ar';

    const [activeCategory, setActiveCategory] = useState('all');
    const scrollContainerRef = useRef(null);

    const products = [
        {
            id: 1,
            title: t('productpage.productcards.card1.title'),
            image: dine,
            category: 'dinde',
            pdfUrl: cataloquedinde
        },
        {
            id: 2,
            title: t('productpage.productcards.card2.title'),
            image: poulet,
            category: 'poulet',
            pdfUrl: cataloquepoulet
        },
        {
            id: 3,
            title: t('productpage.productcards.card3.title'),
            image: nugget,
            category: 'nuggets',
            pdfUrl: cataloquenugget
        }
    ];

    const filterProducts = (category) => {
        setActiveCategory(category);
    };

    const filteredProducts = activeCategory === 'all' 
        ? products 
        : products.filter(product => product.category === activeCategory);

        const handleWheel = (e) => {
            if (isMob && scrollContainerRef.current) {
                e.preventDefault();
                const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
                const scrollAmount = delta > 0 ? 100 : -100;
                scrollContainerRef.current.scrollBy({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
            }
        };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (isMob && scrollContainer) {
            scrollContainer.addEventListener('wheel', handleWheel, { passive: false });
            return () => scrollContainer.removeEventListener('wheel', handleWheel);
        }
    }, [isMob]);

  return (
    <div className={`px-6 sm:px-10 lg:px-28 xl:px-32 xxl:px-40 xxxl:px-52 ${isRTL ? 'font-almarai rtl' : 'font-inter ltr'} w-full mt-10 overflow-hidden`}>
            <HeadingOfSection 
                header={t('productpage.title')}
                span={t('productpage.span')}/>
            {/* Filter Buttons */}
            <div 
                ref={scrollContainerRef}
                className={`flex gap-4 rounded-lg mb-4 sm:mb-8  ${isMob ? 'overflow-x-auto whitespace-nowrap hide-scrollbar  justify-start' : ' justify-center'}`}
                style={isMob ? { scrollBehavior: 'smooth', msOverflowStyle: 'none', scrollbarWidth: 'none' } : {}}
            >
                <button 
                    onClick={() => filterProducts('all')}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl ${isMob ? 'flex-shrink-0' : ''} ${activeCategory === 'all' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.all')}
                </button>
                <button 
                    onClick={() => filterProducts('dinde')}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl ${isMob ? 'flex-shrink-0' : ''} ${activeCategory === 'dinde' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.dinde')}
                </button>
                <button 
                    onClick={() => filterProducts('poulet')}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl ${isMob ? 'flex-shrink-0' : ''} ${activeCategory === 'poulet' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.poulet')}
                </button>
                <button 
                    onClick={() => filterProducts('nuggets')}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl ${isMob ? 'flex-shrink-0' : ''} ${activeCategory === 'nuggets' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.nugget')}
                </button>
            </div>

            {/* Product Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12  py-2 sm:py-4">
                {filteredProducts.map((product) => (
                    <a href={product.pdfUrl} target="_blank" rel="noopener noreferrer" key={product.id} className="bg-white rounded-3xl overflow-hidden shadow-lg aspect-[81/102]" >
                        <div className="relative w-full h-[70%]">
                            <img 
                                loading="lazy"
                                src={product.image} 
                                alt={product.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="p-6 flex flex-col justify-center gap-2 sm:gap-4 items-center h-[30%] bg-[#F7F5F0]">
                            <h3 className="text-lg sm:text-2xl xl:text-xl xxl:text-2xl xxxl:text-3xl xxxxl:text-4xl font-semibold text-center">{product.title}</h3>
                            <a 
                                href={product.pdfUrl}
                                download
                                className="block w-full bg-secondary text-white text-center text-lg sm:text-2xl font-bold my-[6px] sm:py-2 rounded-md hover:bg-secondary/90 transition-colors"
                            >
                                {t('productpage.button')}
                            </a>
                        </div>
                    </a>
                ))}
            </div>
        </div>
  )
}

export default ProductSection